/**
 * Thrown by the tokenRefresh middleware when a 401 indicates the user's
 * session is gone — distinguishes session expiry from generic backend
 * errors so `errorModal/handleError` can suppress the modal during logout.
 */
export class SessionExpiredError extends Error {
  readonly cause?: unknown;

  constructor(message = 'Session expired', cause?: unknown) {
    super(message);
    this.name = 'SessionExpiredError';
    this.cause = cause;
  }
}
